import { Country } from 'react-phone-number-input';

export const convertMarketToPhoneCode = (marketId: string): Country | null => {
  const marketList = ['FR', 'DE', 'UK', 'CH', 'NO', 'SE', 'DK', 'AT', 'US'];
  if (marketId === 'UK') return 'GB';
  if (marketList.includes(marketId)) return marketId as Country;
  return null;
};
